import { EditModeColor } from 'features/siteMapViz'
import { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div<{ $show: boolean }>`
  height: ${({ $show }) => ($show ? '3rem' : '0')};
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 0 1rem;

  background-color: ${EditModeColor};

  transition: height 0.1s ease-in-out;
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
`

const TitleText = styled.span`
  font-weight: bold;
`
const SubtitleText = styled.span``

const ExitButton = styled.button`
  &:hover {
    cursor: pointer;
  }
`

interface EditModePanelProps {
  isInEditMode: boolean
  exitEditMode: () => void
}
export const EditModePanel: FC<EditModePanelProps> = (props) => {
  return (
    <Container $show={props.isInEditMode}>
      <TitleContainer>
        <TitleText>Editing Map</TitleText>
        <SubtitleText>Click a feature to configure</SubtitleText>
      </TitleContainer>
      <ExitButton onClick={props.exitEditMode}>Done</ExitButton>
    </Container>
  )
}
